import React from 'react';
import { Avatar, Box, Card, CardContent, Typography } from '@mui/material';

interface StatCardProps {
    label: string;
    value?: number;
    caption?: string;
    icon: React.ReactNode;
    color: 'primary' | 'info' | 'warning' | 'error' | 'success';
}

// Indicador do painel: rótulo, valor e ícone colorido
export function StatCard({ label, value, caption, icon, color }: StatCardProps) {
    return (
        <Card sx={{ height: '100%' }}>
            <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 2 }}>
                    <Box sx={{ minWidth: 0 }}>
                        <Typography variant="body2" color="text.secondary" fontWeight={500} gutterBottom>{label}</Typography>
                        <Typography variant="h4" component="p" fontWeight={700}>{value ?? 0}</Typography>
                    </Box>
                    <Avatar sx={{ bgcolor: `${color}.main`, color: `${color}.contrastText`, width: 48, height: 48 }}>
                        {icon}
                    </Avatar>
                </Box>
                {caption && <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>{caption}</Typography>}
            </CardContent>
        </Card>
    );
}
